module.exports = __webpack_public_path__ + "static/media/house.6fac5a75.svg";